import React,{useState,useEffect,useRef} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Button} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import moment from 'moment'
import {BsSearch} from 'react-icons/bs'
import { empwiseattApi } from '../../../utils/AdminDashApi/EmpWiseAttApi'
import '../../../sassFiles/sassPages/admindashboard/campwiseatten.scss'
import '../../../sassFiles/sassPages/admindashboard/adminCommon.scss'
import { empAttreportApi } from '../../../utils/AdminDashApi/EmpAttReportApi'
import { BsPlus } from 'react-icons/bs'
import { optionsCampus, optionsClass, optionsShift, optionsdayofmonth, optionsdayofweek, optionsdept, optionsdesignation, optionsexptype, purplebutton40 } from '../../Helper'
import { validationComp, validationDrp } from '../../subComponents/CustomSubComponents/ValidationComp'
import { studentSubjectApi } from '../../../utils/AdminDashApi/StudentSubjectApi'
import { validateTransactionApi } from '../../../utils/AdminDashApi/ValidateTransactionApi'
import { credinfostuApi, sendstucredApi } from '../../../utils/AdminDashApi/SendStuCredApi'
const StudentAttendanceProcessComp = () => {

    const [startdatemain,setstartdatemain] = useState("")
    const [borderstartdatemain,setborderstartdatemain] = useState("")
    const [labelstartdatemain,setlabelstartdatemain] = useState("")

    const [enddatemain,setenddatemain] = useState("")
    const [borderenddatemain,setborderenddatemain] = useState("")
    const [labelenddatemain,setlabelenddatemain] = useState("")

    const [isAssignrolechk,setisAssignrolechk] = useState("")

    const handleStartDatemain = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            setstartdatemain(moment(dtfinalc).format("YYYY-MM-DD"))
        }  
    }

    const handleenddatemain = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            setenddatemain(moment(dtfinalc).format("YYYY-MM-DD"))
        }  
    }

    const handleisAssignrolechk = event => {
        if (event.target.checked) {
          console.log('✅ Checkbox is checked');
          
        } else {
            console.log('⛔️ Checkbox is NOT checked');
            
        }
        setisAssignrolechk(current => !current);
      };

    const continueButton=()=>{

    }

  return (
    <>
        <div className="d-flex flexvaluecomp htshiftsetup">
            <SidebarOfAdash />
            <div className="contentpartwidthwrapper">
                <HeaderofAdash head="Student Attendence Process" />
                <div className="contentofadmindash contentflexvalue">
                    <Row className="sendstucredmain">
                        <Col lg={9} className='m-auto'>
                        
                          <Row>
                            <Col lg={4} className="pr7">
                            <div className="basicinput">
                                <p>Start Date</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div className="inputgap h35">
                                <DatePicker
                                    
                                    value={startdatemain}
                                    onChange={(newvaldob)=>handleStartDatemain(newvaldob)}
                                    renderInput={(params) => <TextField style={borderstartdatemain == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                        ...params.inputProps,
                                        placeholder: "Start Date"
                                        }} error={false} />}
                                />
                                <label>{labelstartdatemain}</label>
                                </div>
                                </LocalizationProvider>
                            </div>
                            </Col>
                            <Col lg={4} className="pr7 pl7">
                            <div className="basicinput">
                                <p>End Date</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div className="inputgap h35">
                                <DatePicker
                                    
                                    value={enddatemain}
                                    onChange={(newvaldob)=>handleenddatemain(newvaldob)}
                                    renderInput={(params) => <TextField style={borderenddatemain == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params}inputProps={{
                                        ...params.inputProps,
                                        placeholder: "End Date"
                                        }} error={false} />}
                                />
                                <label>{labelenddatemain}</label>

                                </div>
                                </LocalizationProvider>
                            </div>
                            </Col>
                            <Col lg={3} className="pl7">
                                <div className="purplebutton" style={{marginTop:"18px"}}>
                                <button className='px-4 py-2' onClick={continueButton}>
                                        Run Process
                                </button>

                                </div>
                            </Col>
                          </Row>
                        </Col>
                    </Row>
                  
                    
                </div>
            </div>
        </div>
    </>
  )
}

export default StudentAttendanceProcessComp